angular.module 'zc.core'

.filter 'zcDate', ($filter) ->
  SHORT_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.shortFormat')
  LONG_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.longFormat')
  HM_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.timeFormat')

  (date, options = {}) ->
    if !date
      return ''

    if options.dateOnly
      short_format = SHORT_FORMAT
      long_format = LONG_FORMAT
    else
      short_format = "#{SHORT_FORMAT} #{HM_FORMAT}"
      long_format = "#{LONG_FORMAT} #{HM_FORMAT}"

    if options.smart
      if moment().isSame(date, 'year')
        $filter('date')(date, short_format)
      else
        $filter('date')(date, long_format)
    else if options.format
      $filter('date')(date, options.format)
    else if options.short
      $filter('date')(date, short_format)
    else
      $filter('date')(date, long_format)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/zc_date.coffee